// extracted by mini-css-extract-plugin
export default {"switchLabel":"SwitchWindow_switchLabel__eDKBr","switchInput":"SwitchWindow_switchInput__Z60fw","switchText":"SwitchWindow_switchText__W7Saz"};